import styled from 'styled-components'

export const BlurOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 30;

  display: flex;
  align-items: center;
  justify-content: center;

  /* Dark overlay */
  background: rgba(0, 0, 0, 0.45);

  /* Blur the content behind the overlay */
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);

  overflow: hidden;
`

export const BlurContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 24px;
  max-width: ${({ isMobile }) => (isMobile ? '380px' : '370px')};
  color: #fff;
`

export const ShowContent = styled.button`
  background: none;
  border: ${({ isMobile, theme }) =>
    isMobile ? `1px solid ${theme.app.accent}` : 'none'};
  border-radius: ${({ isMobile }) => (isMobile ? '40px' : '0')};
  font-size: 14px;
  color: ${({ theme }) => theme.app.accent};
  font-weight: 600;
  cursor: pointer;
  padding: ${({ isMobile }) => (isMobile ? '8px 16px' : '0')};

  &:hover {
    opacity: 0.8;
  }
`;
export const BlurImageTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.app.text};
`

export const BlurImageDescription = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.app.iconlabel};
`